import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-radio-button', {
    position: 'absolute',
    cursor: 'pointer',
    width: '15px',
    height: '15px',
    outline: 0,
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    backgroundPosition: 'left center',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/radio_button_empty_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-radio-button:hover, .tb-radio-button:focus', {
    backgroundImage: 'url(img/radio_button_empty_hover.svg?1_0_9606_yabs0uv7t1h)',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-radio-button.tb-disabled', {
    backgroundImage: 'url(img/radio_button_empty_disabled.svg?1_0_9606_yabs0uv7t1h)',
    cursor: 'default',
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('.tb-radio-button.tb-selected', {
    backgroundImage: 'url(img/radio_button_selected_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-radio-button.tb-selected:hover, .tb-radio-button.tb-selected:focus', {
    backgroundImage: 'url(img/radio_button_selected_hover.svg?1_0_9606_yabs0uv7t1h)',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-radio-button.tb-selected.tb-disabled', {
    backgroundImage: 'url(img/radio_button_selected_disabled.svg?1_0_9606_yabs0uv7t1h)',
    cursor: 'default',
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('.tb-radio-button.tb-mixed', {
    backgroundImage: 'url(img/radio_button_mixed_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-radio-button.tb-mixed:hover, .tb-radio-button.tb-mixed:focus', {
    backgroundImage: 'url(img/radio_button_mixed_hover.svg?1_0_9606_yabs0uv7t1h)',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-radio-button.tb-mixed.tb-disabled', {
    backgroundImage: 'url(img/radio_button_mixed_disabled.svg?1_0_9606_yabs0uv7t1h)',
    cursor: 'default',
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('.tb-radio-button-label', {
    marginLeft: '21px',
    lineHeight: '15px',
    cursor: 'pointer',
});

cssRule('.tb-radio-button-label.tb-disabled', {
    cursor: 'default',
});

cssRule('.tb-radio-button-label .tb-inline-text-box', {
    display: 'inline-block',
    height: '23px',
    marginRight: '3px',
    verticalAlign: 'top',
});

cssRule('.tb-radio-button-group', {
    position: 'relative',
});

cssRule('.tb-radio-button-group.tb-with-inline-text-box >.tb-radio-button', {
    height: '23px',
});

cssRule('.tb-radio-button-group.tb-with-inline-text-box >.tb-radio-button-label', {
    height: '23px',
    lineHeight: '23px',
});

